import { ReportDetailSummaryOnly } from "../../reports/ReportDetail";

const Summary360SocialAlternate = () => {
  return <ReportDetailSummaryOnly />;
};

export default Summary360SocialAlternate;
